module.exports = __webpack_public_path__ + "img/friendly-resort-3.87e8f399.jpg";